import { useFlags } from 'hooks/useFeatureFlag';
import { useCurrentUserRole } from 'hooks/api';
import { useCurrentUserFeatureList } from 'hooks/api/useFeatures';
import { IAction } from '../constant';
import { filterVisibleActions } from '../helpers';
import { CustomerDashboardHeader } from './CustomerDashboardHeader';
import { AccountDetailHeader } from './AccountDetailHeader';
import { AdminTopHeader } from './AdminTopHeader';

interface Props {
  actions: IAction[];
}

export const HeaderDesktop = ({ actions }: Props) => {
  const { isAdmin } = useCurrentUserRole();
  const flags = useFlags();
  const featureList = useCurrentUserFeatureList();
  const enabledActions = filterVisibleActions(actions, flags, featureList);
  const isAccountMenuItems = enabledActions.every(
    (item) => item.type === 'account',
  );

  if (isAccountMenuItems) {
    return <AccountDetailHeader actions={actions} />;
  }

  if (isAdmin) {
    return <AdminTopHeader actions={actions} />;
  }

  return <CustomerDashboardHeader actions={actions} />;
};
